<template>
  <div class="child">
    <div class="content">
      <SelectRadio :radioData="questions" :Finished="Finished1"></SelectRadio>
      <SelectRadio v-show="questionId" :radioData="radioData" :Finished="Finished2"></SelectRadio>
      <EvidenceBlock v-show="questionId" :max="9" accept="image/*" :evidenceData="evidenceData" :Finished="evidenceFinished"></EvidenceBlock>
    </div>
    <z-button-group>
      <z-button :loading="sharedData.globalLoading" :disabled="!canSubmit" type="primary" @click="submit">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import SelectRadio from '../components/SelectRadio'
import EvidenceBlock from '../components/EvidenceBlock'
import { newReportGetQuestion } from '@api/resourceApi'
import { Button, ButtonGroup } from '@zz-common/zz-ui'
export default {
  name: 'RouteChild',
  components: {
    zButton: Button,
    zButtonGroup: ButtonGroup,
    SelectRadio,
    EvidenceBlock
  },
  inject: ['sharedData', 'globalSubmit'],
  data() {
    return {
      evidenceData: {
        title: '请填写举报原因',
        text: '如有其他证据证明对方的违规行为，请补充',
        placeholder: '请描述事情经过'
      },
      chooseType: '', //勾选证据类型 1商品2私信3订单
      chooseEvidence: '', //1 商品是商品id 2 私信是私信内容 3 订单是订单id  多个用逗号分割
      questionId: '', //选择的问题id
      questionDesc: '', //选择的问题
      pics: '', //凭证照片
      content: '', //凭证描述 多个用逗号分割
      //选择问题
      questions: {},
      radioData: {
        question: '请选择证据类型',
        answer: [
          {
            id: '2',
            letter: true,
            desc: '私信'
          },
          {
            id: '1',
            product: true,
            desc: '商品'
          },
          {
            id: '3',
            order: true,
            desc: '订单'
          }
        ]
      }
    }
  },
  created() {
    const searchtype = this.sharedData.firstReason.id
    console.log('看看提交参数', searchtype)
    newReportGetQuestion({ type: searchtype }).then(res => {
      this.questions = res
    })
  },
  computed: {
    canSubmit() {
      if (this.sharedData.evidenceLoading) return false
      return this.chooseEvidence && this.chooseType && this.questionId && this.content.length >= 5
    }
  },
  methods: {
    Finished1(data) {
      this.questionId = data.evidence
      this.questionDesc = data.desc
    },
    Finished2(data) {
      this.chooseType = data.evidence
      if (data.evidence == '2') {
        this.chooseEvidence = JSON.stringify(data.selectLetter)
      }
      if (data.evidence == '1') {
        this.chooseEvidence = data.selectProduct.map(t => t.infoId).join(',')
      }
      if (data.evidence == '3') {
        this.chooseEvidence = data.selectOrder.map(t => t.orderId).join(',')
      }
    },
    evidenceFinished(data) {
      this.content = data.message
      this.pics = data.files.map(t => t.url)
    },
    submit() {
      const params = {
        chooseType: this.chooseType,
        chooseEvidence: this.chooseEvidence,
        questionId: this.questionId,
        questionDesc: this.questionDesc,
        pics: JSON.stringify(this.pics),
        content: this.content
      }
      this.globalSubmit(params)
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>